import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MD_DIALOG_DATA, MdDialogRef } from '@angular/material';
import { BaseBannerModel } from 'app/model/banner/banner';
import $ from 'jquery';

@Component({
  selector: 'act-dialog-banner-overlay',
  templateUrl: './dialog-banner-overlay.component.html',
  styleUrls: ['./dialog-banner-overlay.component.scss']
})
export class DialogBannerOverlayComponent implements OnInit, OnDestroy {
  public elementId = 'banner-overlay';
  public owlCarouselInitialed = false;
  private owlCarousel: any;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: BaseBannerModel[],
    public dialogRef: MdDialogRef<DialogBannerOverlayComponent>,
  ) { }

  ngOnInit() {
    this.initCarousel();
  }

  ngOnDestroy() {
    this.owlCarousel && this.owlCarousel.trigger("destroy.owl.carousel");
  }

  initCarousel() {
    setTimeout(() => {
      this.owlCarousel = $('.banner-overlay-owl');
      if (this.owlCarousel && this.owlCarousel.children().length === this.data.length) {
        this.owlCarousel.owlCarousel({
          loop: true,
          nav: true,
          navText: [
            '<i class="icon-arrow-left-circle"></i>',
            '<i class="icon-arrow-right-circle"></i>'
          ],
          items: 1,
          autoplay: true,
          autoplayTimeout: 5000,
          autoplayHoverPause: true
        });
        this.owlCarouselInitialed = true;
      } else {
        this.initCarousel();
      }
    }, 500);
  }

  onClose() {
    this.dialogRef.close(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-banner-overlay/dialog-banner-overlay.component.ts